import { render, staticRenderFns } from "./CandidatesActions.vue?vue&type=template&id=2354c340&lang=pug&"
import script from "./CandidatesActions.vue?vue&type=script&lang=js&"
export * from "./CandidatesActions.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
